<div #blockBody class="external-pre-match-predictions" class="{{ displayMode }}">
	<div class="match-page-loading" *ngIf="gamesLoading && !gamesError">
		<span>
			Loading {{ localisationService.localeTerm('match', '') }} data<span class="animated-ellipsis"><span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></span>
		</span>
	</div>
	<div class="match-page-loading" *ngIf="!gamesLoading && !gamesError && noGamesAvailable">
		<span class="error-main">
			<span>
				There are no {{ localisationService.localeTerm('matches', '') }} available right now
			</span>
		</span>
	</div>
	<div class="match-page-loading" *ngIf="gamesError">
		<span class="error-main">
			<span>
				We are having trouble loading {{ localisationService.localeTerm('match', '') }} data
			</span>
		</span>

		<span>
			Please
			<span class="retry-link"
				(click)="reloadSingleGame(configurationObject.matchID)">
				try again
			</span>
		</span>
	</div>
	<div class="match-page-tabs" *ngIf="!gamesLoading && !gamesError && !noGamesAvailable">
		<div class="match-page-tab-selector">
			<div class="tab-option selected-option">
				<span>
					{{ localisationService.localeTerm((match.MatchData.Sport | lowercase) === 'ten' ? 'prematch_tennis' : 'prematch', 'title-case') }}
					Probabilities
				</span>
			</div>
		</div>
		<div class="match-page-tab predictions">
			<app-pre-match-predictions
				[class]="displayMode"
				[displayMode]="displayMode"
				[match]="match"
				[withinMatch]="false"
				[h2hBettingDataUnavailable]="h2hBettingDataUnavailable"
				[totalDataUnavailable]="totalDataUnavailable"
				[lineDataUnavailable]="lineDataUnavailable"
				[btsDataUnavailable]="btsDataUnavailable"
				[firstSetDataUnavailable]="firstSetDataUnavailable"
			></app-pre-match-predictions>
		</div>
	</div>
</div>
